import type { TrainingLessonSpecific } from './trainingLessonUi';

export const priest2PastoralEs: TrainingLessonSpecific = {
  intro:
    'El Presbítero puede efectuar bautismos por inmersión cuando se le asigna, con autorización del obispo. La confirmación (conferir el don del Espíritu Santo) requiere Sacerdocio de Melquisedec; el Presbítero no la realiza en bautismos de conversos. En el templo, los presbíteros sí pueden participar en ordenanzas vicarias (bautismos y confirmaciones) a favor de los fallecidos. Su rol principal es el bautismo, la Santa Cena y la obra misional. Acompañar bien a un nuevo miembro reduce desánimo; la delegación correcta protege la reverencia de la ordenanza.',
  objectives: [
    'Entender el rol del Presbítero en bautismos (puede efectuarlos bajo autorización del obispo).',
    'Comprender que la confirmación de miembros nuevos requiere Sacerdocio de Melquisedec.',
    'Aprender a servir con respeto y coordinación.',
    'Fortalecer a miembros nuevos y acompañar a los que se preparan para ordenanzas.',
    'Plan personal de servicio pastoral.',
  ],
  briefHeading: 'Bautismo, confirmación y acompañamiento',
  briefBody:
    'Coordina siempre con quien posee las llaves. En la obra viviente, el presbítero bautiza cuando se le delega; la confirmación la realizan élderes. En el templo sirves en ordenanzas vicarias. El acompañamiento pastoral es parte del sacerdocio.',
  scriptures: [
    { ref: 'DyC 20:41–43', text: 'Bautismo: por inmersión, en el nombre del Padre, del Hijo y del Espíritu Santo.' },
    { ref: 'Moroni 6:1–4', text: 'Bautismo y confirmación: dignidad y preparación.' },
    { ref: 'DyC 18:10–16', text: 'El valor de las almas es grande a la vista de Dios.' },
    { ref: 'Mosíah 18:8–10', text: 'Llevar las cargas unos de otros, consolar a los que necesitan consuelo.' },
    { ref: 'DyC 107:13–14', text: 'El Sacerdocio Aarónico tiene las llaves del ministerio de ángeles.' },
  ],
  didYouKnow: [
    'El Presbítero puede bautizar bajo delegación del obispo; la confirmación requiere Melquisedec.',
    'En el templo, los presbíteros participan en bautismos y confirmaciones vicarias a favor de los fallecidos.',
    'Todas las ordenanzas se realizan bajo la dirección de quien posee las llaves (obispo o presidente de misión).',
  ],
  practiceItems: [
    'Acompañar a un nuevo miembro (o converso reciente) en una actividad o reunión',
    'Coordinar con un líder para saber cómo puedo ayudar en bautismos (o en ordenanzas vicarias del templo)',
    'Enviar un mensaje de ánimo a alguien que se prepara para una ordenanza',
    'Repasar el protocolo de bautismo o Santa Cena según mi delegación',
    'Observar y aprender de un Presbítero que sirve con dignidad',
    'Hacer un plan de seguimiento para 1 persona que acaba de bautizarse o confirmarse',
  ],
  reflectionQuestions: [
    '¿A quién puedo acompañar esta semana en su preparación para una ordenanza?',
    '¿Qué me cuesta más: coordinar con líderes o acercarme a los nuevos?',
    '¿Cómo cuidaré la reverencia cuando participe en bautismos o en ordenanzas del templo?',
  ],
  actionText: 'Acompañar a 1 persona en su preparación para una ordenanza.',
};
